module.exports = __webpack_public_path__ + "courseWrapper-5b84d4a5800c546ae927e7b07f60f2f8.png";